import { render, staticRenderFns } from "./BitsAboutIt.vue?vue&type=template&id=3d8ccd83&scoped=true&"
import script from "./BitsAboutIt.vue?vue&type=script&lang=js&"
export * from "./BitsAboutIt.vue?vue&type=script&lang=js&"
import style0 from "./BitsAboutIt.vue?vue&type=style&index=0&id=3d8ccd83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ccd83",
  null
  
)

export default component.exports